<nz-layout class="app-layout">
  <nz-sider  class="menu-sidebar" nzCollapsible nzWidth="256px" nzBreakpoint="md" [(nzCollapsed)]="isCollapsed"
    [nzTrigger]="null">
    <div class="sidebar-logo">
      <a href="#" target="_blank">
        <img src="assets/logo.png" class="img-fluid" alt="logo">
        <h1>APS</h1>
      </a>
    </div>
    <!-- <li nz-menu-item><span><i nz-icon type="user"></i><span class="nav-text">nav 1</span></span></li> -->
    <ul  nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="isCollapsed" class="sideBar">
        <li nz-submenu [(nzOpen)]="openMap[menu.areaName]" (nzOpenChange)="openHandler(menu.areaName)" [nzTitle]="menu.areaName" nzIcon="dashboard" *ngFor="let menu of menus">
          <ul *ngFor="let pageLink of menu.areaPages">
            <li nz-menu-item nzMatchRouter class="menuHeight">
              <a (click)="addTab(pageLink)">{{ pageLink.pageName }}</a>
            </li>
          </ul>
        </li>
    </ul>
  </nz-sider>

  <nz-layout style="width: 100vh">
    <nz-header>
      <div class="app-header">
        <span class="header-trigger" id="hTrigger" (click)="isCollapsed = !isCollapsed;">
          <i class="trigger" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"></i>
        </span>
        <span class="app-header-search">
          <input nz-input [(ngModel)]="userSearch" (keydown.enter)="onSearchUser()" placeholder="Search customers" [nzAutocomplete]="auto">
          <nz-autocomplete [nzDefaultActiveFirstOption]="false" #auto>
            <nz-auto-option *ngFor="let user of searchedUser" (click)="onUserClick(user)" [nzValue]="userSearch">
              <div class="d-flex justify-content-between">
                <span class="d-flex align-items-center">
                  <span style="font-weight: 500; font-size: 16px;">{{ user.name }}</span>&nbsp;<span style="color:#c3c3c3">{{ user.fileNo }}</span>
                </span>
              </div>
              <div class="d-flex justify-content-between">
                <span>{{ user.primaryMobileNo }}</span>
                <span>Contact: {{ user.contactPersonName }}</span>
              </div>
            </nz-auto-option>
          </nz-autocomplete>
        </span>
        <span class="avatar" nz-dropdown [nzDropdownMenu]="menu">
          <nz-avatar nzIcon="user"></nz-avatar>
        </span>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul nz-menu nzSelectable>
            <li nz-menu-item (click)="visible = true;">Reset Password</li>
            <li nz-menu-item (click)="logOut()">Logout</li>
          </ul>
        </nz-dropdown-menu>
      </div>
    </nz-header>

    <nz-content style="height: calc( 100% - 64px);"> 
      <div class="inner-content">
        <nz-tabset [nzType]="'card'" [nzSize]="'small'" [nzAnimated]="'{inkBar: true, tabPane: true;}'"
          [nzSelectedIndex]="selectdTab">
          <nz-tab *ngFor="let tab of navLinks" [nzTitle]="titleTemplate" style="border: none;">
            <ng-template #titleTemplate>
              <!-- <a routerLink="{{tab.link}}"> -->
              <div>
                {{ tab.label }}
                <i nz-icon nzType="close" (click)="closeTab(tab)" class="ant-tabs-close-x"></i>
              </div>
              <!-- </a> -->
            </ng-template>
            <nz-card style="border-top: none;" class="p-0">
              <!-- <ng-container *ngComponentOutlet="tab.component;injector:tab.permission"></ng-container> -->
              <ndc-dynamic style="height: 100%; padding: 0px;" [ndcDynamicComponent]="tab.component"></ndc-dynamic>
            </nz-card>
            <!-- Content of {{ tab.label }} -->
          </nz-tab>
        </nz-tabset>
        <!-- <router-outlet></router-outlet> -->
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>

<app-pass-reset [visible]="visible" (visible_)="closePassReset($event)"></app-pass-reset>